// this is in separate file to overcome JS import hoisting

import jQuery from "jquery";
Object.assign(window, { $: jQuery, jQuery })
